import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { format, addDays, subDays } from 'date-fns';
import { useAppData } from '../../context/AppContext';
import OvernightIndices from './OvernightIndices';
import DailyNotes from './DailyNotes';
import InFocus from './InFocus';
import { exportFullDailyPlannerPDF } from '../../utils/pdf';
import SafeIcon from '../../common/SafeIcon';

export default function PlannerView() {
  const { currentDate, setCurrentDate, currentDaily, watchlists } = useAppData();
  const [activeTab, setActiveTab] = useState('indices');

  const handleMasterExport = () => {
    const dateStr = format(currentDate, 'EEEE, dd MMMM yyyy');
    exportFullDailyPlannerPDF(dateStr, currentDaily, watchlists);
  };

  const tabs = [
    { id: 'indices', label: 'Overnight Indices', icon: FiIcons.FiBarChart2 },
    { id: 'notes', label: 'Daily Notes', icon: FiIcons.FiEdit3 },
    { id: 'focus', label: 'In Focus', icon: FiIcons.FiTarget },
  ];

  return (
    <div className="h-full overflow-y-auto bg-app-bg px-4 py-6 md:px-8 lg:px-12">
      <div className="max-w-5xl mx-auto space-y-6 pb-20">
        
        {/* Header with Date and Master Export */}
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between bg-app-surface p-6 rounded-xl border border-app-border shadow-2xl">
          <div className="flex items-center gap-6">
            <button 
              onClick={() => setCurrentDate(subDays(currentDate, 1))}
              className="p-2 hover:bg-app-border rounded-full transition-all text-app-muted hover:text-app-accent border border-transparent hover:border-app-border"
            >
              <FiIcons.FiChevronLeft size={28} />
            </button>
            <div className="text-center md:text-left">
              <h1 className="text-2xl font-black text-white uppercase tracking-tighter">
                {format(currentDate, 'EEEE')}
              </h1>
              <p className="text-xs text-app-accent font-mono font-bold mt-0.5 tracking-widest">
                {format(currentDate, 'dd MMMM yyyy').toUpperCase()}
              </p>
            </div>
            <button 
              onClick={() => setCurrentDate(addDays(currentDate, 1))}
              className="p-2 hover:bg-app-border rounded-full transition-all text-app-muted hover:text-app-accent border border-transparent hover:border-app-border"
            >
              <FiIcons.FiChevronRight size={28} />
            </button>
          </div>
          <button 
            onClick={handleMasterExport}
            className="flex items-center gap-2 bg-app-accent text-black px-6 py-3 rounded-lg text-xs font-black uppercase tracking-[0.15em] hover:bg-yellow-500 transition-all shadow-xl shadow-app-accent/10 active:scale-95"
          >
            <FiIcons.FiPrinter size={16} /> Export Full Plan
          </button>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-2 p-1.5 bg-app-surface border border-app-border rounded-xl">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 min-w-[140px] flex items-center justify-center gap-3 py-3.5 rounded-lg text-xs font-black uppercase tracking-widest transition-all ${
                activeTab === tab.id 
                  ? 'bg-app-accent text-black shadow-lg shadow-app-accent/10' 
                  : 'text-app-muted hover:text-white hover:bg-white/5'
              }`}
            >
              <SafeIcon icon={tab.icon} size={16} />
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
          {activeTab === 'indices' && <OvernightIndices />}
          {activeTab === 'notes' && <DailyNotes />}
          {activeTab === 'focus' && <InFocus />}
        </div>

      </div>
    </div>
  );
}